export function getPlaceholderImage(mimeType) {
    switch (mimeType) {
        case "image/tiff":
        case "image/png":
        case "image/jpeg":
            return "/img/thumbnails/tn_img.png";

        case "application/pdf":
            return "/img/thumbnails/tn_pdf.png";

        case "application/vnd.oasis.opendocument.spreadsheet":
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return "/img/thumbnails/tn_xlsx.png";

        case "text/csv":
            return "/img/thumbnails/tn_xlsx.png";

        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return "/img/thumbnails/tn_docx.png";

        default:
            return "/img/thumbnails/tn_blank.png";
    }
}

export default function MediaThumbnail({ fileMimeType = "" }) {
    return getPlaceholderImage(fileMimeType);
}
